import { AmbientBackground, buttonVariants } from '@intelliauth/ui'
import { ShieldOff } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function ForbiddenPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <AmbientBackground variant="full" />
      <div className="text-center max-w-md px-6 animate-fade-in">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-500/10">
          <ShieldOff className="h-8 w-8 text-red-400" />
        </div>
        <h1 className="text-6xl font-bold text-foreground">403</h1>
        <p className="mt-4 text-lg text-muted-foreground">Access denied</p>
        <p className="mt-2 text-sm text-muted-foreground/70">
          You don't have permission to access this resource. Contact your organization admin if you
          believe this is a mistake.
        </p>
        <div className="mt-8 flex items-center justify-center gap-4">
          <Link to="/dashboard" className={buttonVariants({ variant: 'primary' })}>
            Go to Dashboard
          </Link>
          <Link
            to="/"
            className="h-10 px-6 inline-flex items-center text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  )
}
